import {
  httpRequest,
  querystringBuilderByObject
} from '@common/util/api-common.util';

export default class RelatorioApi {
  static get(laudo) {
    return httpRequest(`laudo-critico-notificacao/${laudo}`).then(
      json => json.data
    );
  }
  static post({ laudo, medico, notificacao, telefone }) {
    const body = { laudo, medico, notificacao, telefone };
    return httpRequest(`laudo-critico-notificacao`, 'POST', body).then(
      json => json.data
    );
  }
  static getLaudos(pagina, params) {
    const query = querystringBuilderByObject({ critico: true, ...params });
    return httpRequest(`laudos/${pagina}/20${query}`).then(json => json.data);
  }

  static getLaudosSemCid(pagina, tamanho, params) {
    return httpRequest(`Diagnosticos/cid/relatorio/${pagina}/${tamanho}?DataIni=${params.dataIni}&DataFim=${params.dataFim}&Ordenacao=${params.ordenacao}`)
  }
}



// WEBPACK FOOTER //
// ./src/pages/relatorio/relatorio.api.js